import React, { useRef, useState } from "react";
import { Button, Modal } from "antd";
import { YoutubeFilled } from "@ant-design/icons";
import { MdOutlineTouchApp } from "react-icons/md";
import clickIcon from "./../../../../assets/images/video-cursor.gif";
import playIcon from "./../../../../assets/images/thank-you/video-play-banner.webp";

const VideoModal = ({ showArrow }: { showArrow?: boolean }) => {
  const [modal2Open, setModal2Open] = useState(false);

  const iframeRef = useRef<HTMLIFrameElement>(null);

  const handleModalClose = () => {
    // Stop the video by resetting the iframe src
    if (iframeRef.current) {
      const currentSrc = iframeRef.current.src;
      iframeRef.current.src = "";
      setTimeout(() => {
        if (iframeRef.current) {
          iframeRef.current.src = currentSrc;
        }
      }, 100);
    }
    setModal2Open(false);
  };

  return (
    <>
      <div className="btn-holder video-modal">
        <Button
          type="text"
          onClick={() => setModal2Open(true)}
          className="video-modal-btn relative"
        >
          <YoutubeFilled />
             {/* <img src={playIcon}  /> */}
          <div className="cursor">
            <img src={clickIcon} alt="click" height={120} />
          </div>
        </Button>
      </div>


      <Modal
        title="This video is Made For You!"
        centered
        open={modal2Open}
        onOk={handleModalClose}
        onCancel={handleModalClose}
        footer={false}
        width="90vw"
        style={{ maxWidth: "1200px" }}
      >
        {modal2Open && (
          <iframe
            ref={iframeRef}
            width="100%"
            height="500"
            src="https://www.youtube.com/embed/aJ_nzg2-k24?si=shjJu9vruJXj2dcl&enablejsapi=1"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            style={{
              borderRadius: "15px",
            }}
          ></iframe>
        )}
      </Modal>
    </>
  );
};

export default VideoModal;
